import React from "react";
import MobileMenu from "../../mobileComponents/mobileMenuScreen/Index";

const BankPage = () => {
  return <MobileMenu />;
};

export default BankPage;
